function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNativeSvg = _interopRequireWildcard(require("react-native-svg/lib/commonjs/ReactNativeSVG.web"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var VerticalDotLine = function VerticalDotLine(_ref) {
  var styles = _ref.styles,
    _ref$lineLength = _ref.lineLength,
    propLineLength = _ref$lineLength === void 0 ? 26 : _ref$lineLength,
    testID = _ref.testID;
  var _ref2 = styles || {},
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'white' : _ref2$color,
    _ref2$dotSize = _ref2.dotSize,
    dotSize = _ref2$dotSize === void 0 ? 4 : _ref2$dotSize,
    _ref2$lineLength = _ref2.lineLength,
    lineLength = _ref2$lineLength === void 0 ? propLineLength : _ref2$lineLength,
    _ref2$gap = _ref2.gap,
    gap = _ref2$gap === void 0 ? 1 : _ref2$gap;
  var dots = [];
  var totalHeight = lineLength + gap;
  var numDots = Math.ceil(totalHeight / (dotSize + gap));
  for (var i = 0; i < numDots; i++) {
    var y = i * (dotSize + gap);
    dots.push((0, _jsxRuntime.jsx)(_reactNativeSvg.Circle, {
      cx: dotSize / 2,
      cy: y + dotSize / 2,
      r: dotSize / 2,
      fill: color,
      testID: "Dot"
    }, i));
  }
  return (0, _jsxRuntime.jsx)(_reactNativeSvg["default"], {
    height: totalHeight,
    width: dotSize,
    testID: testID,
    children: dots
  });
};
var _default = exports["default"] = VerticalDotLine;